import { useQuery } from '@tanstack/react-query';
import { getJson } from './http.js';

export interface RecallView {
  recallId: string;
  batch: string;
  sku: string;
  reason: string;
  issuedAt: string;
  deadline: string;
  status: string;
  reportedAt: string | null;
}
export interface RecallDetail extends RecallView {
  products: {
    productId: string;
    sku: string;
    batch: string;
    sourceSpaceId: string;
    quarantinedAt: string | null;
    status: string;
  }[];
  notifications: { orderId: string; productIds: string[]; notifiedAt: string | null }[];
  derivedBatches: { batch: string; sku: string; sourceBatch: string }[];
  localOnly: { salesOrderId: number; productIds: string[] }[];
}
const REFRESH_MS = 15_000;
export function useRecalls() {
  return useQuery({
    queryKey: ['recalls'],
    queryFn: () => getJson<RecallView[]>('/api/recalls'),
    refetchInterval: REFRESH_MS,
  });
}
export function useRecall(recallId: string) {
  return useQuery({
    queryKey: ['recalls', recallId],
    queryFn: () => getJson<RecallDetail>(`/api/recalls/${encodeURIComponent(recallId)}`),
    enabled: recallId !== '',
    retry: false,
    refetchInterval: REFRESH_MS,
  });
}
